import { FocusKeyManager } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Optional, Output, QueryList, SkipSelf, ViewChildren, ViewEncapsulation } from '@angular/core';
import { PhxFocusableItemDirective } from '@components/date-picker/phx-focusable-item.directive';

import { PHOENIX_CONTEXTS, PhxContextService } from '../../services/phx-context-service';

import { KeyboardKeys } from '../../helpers/KeyboardKeys.enum';
import { PhxAddonOptions } from './types';

@Component({
  selector: 'phx-date-picker-group',
  templateUrl: './phx-date-picker-group.component.html',
  styleUrls: ['./phx-date-picker-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-date-picker-group',
    '[class.phx-filter]': 'phxStyleType === PHOENIX_CONTEXTS.FILTER',
  },
})
export class PhxDatePickerGroupComponent {
  public phxOpen: boolean = false;
  public readonly PHOENIX_CONTEXTS = PHOENIX_CONTEXTS;
  public phxStyleType: PHOENIX_CONTEXTS;
  @Input() public phxPrefixDisabled: boolean = false;
  @Input() public phxAddonOptions: PhxAddonOptions;
  @Input() public phxAddonText: string;
  @Input() public phxAddonSelectedKey: string = 'created-at';
  @Output() public phxAddonChanged: EventEmitter<string> = new EventEmitter();

  @ViewChildren('addonItem')
  private _focusableItems: QueryList<PhxFocusableItemDirective>;
  private keyManager: FocusKeyManager<PhxFocusableItemDirective>;

  constructor(@Optional() @SkipSelf() contextService: PhxContextService) {
    this.phxStyleType = contextService?.getType();
  }

  @HostListener('keydown', ['$event'])
  public onHostKeydown(event: KeyboardEvent): void {
    switch (event.code) {
      case KeyboardKeys.ARROW_LEFT:
      case KeyboardKeys.ARROW_RIGHT:
      case KeyboardKeys.ARROW_UP:
      case KeyboardKeys.ARROW_DOWN:
      case KeyboardKeys.SPACE:
        event.preventDefault();
        break;
      case KeyboardKeys.ESC:
        event.preventDefault();
        this.phxOpen = false;
        break;
    }
  }

 public onAddonChanged(addon: string): void {
    this.phxAddonSelectedKey = addon;
    this.phxAddonChanged.emit(addon);
  }

  public onListKeydown(event: KeyboardEvent, addon: string): void {
    switch (event.code) {
      case KeyboardKeys.ARROW_LEFT:
      case KeyboardKeys.ARROW_RIGHT:
      case KeyboardKeys.ARROW_UP:
      case KeyboardKeys.ARROW_DOWN:
      case KeyboardKeys.TAB:
        event.preventDefault();
        break;
      case KeyboardKeys.ESC:
        this.phxOpen = false;
        break;
      case KeyboardKeys.ENTER:
      case KeyboardKeys.SPACE:
        this.onAddonChanged(addon);
        break;
    }
  }

  public dropdownChanged(dropdownOpen: boolean): void {
    this.keyManager = new FocusKeyManager(this._focusableItems);
    setTimeout(() => {
      if(dropdownOpen) {
        this.keyManager.setFirstItemActive();
        this.phxOpen = dropdownOpen;
      }
    },100)
  }
}
